import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

type Props = {
    label: string;
    value: string;
};

export function QuotaHeaderValue(props: Props) {
    return (
        <Stack isHorizontal={true} spacing={6} alignItems='center'>
            <Body size='small' color='light'>
                {props.label}
            </Body>
            <Body isBold={true} size='small' color='dark'>
                {props.value}
            </Body>
        </Stack>
    );
}
